import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Bautagebuch from './pages/Bautagebuch';
import BautagebuchForm from './pages/BautagebuchForm';
import BautagebuchDetail from './pages/BautagebuchDetail';
import Zeiterfassung from './pages/Zeiterfassung';
import Material from './pages/Material';
import Fotos from './pages/Fotos';
import Baustellen from './pages/Baustellen';
import Mitarbeiter from './pages/Mitarbeiter';
import './App.css';

function PrivateRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="loading-screen"><div className="spinner" /></div>;
  return user ? children : <Navigate to="/login" />;
}

function AdminRoute({ children }) {
  const { user } = useAuth();
  return user?.role === 'admin' ? children : <Navigate to="/" />;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
            <Route index element={<Dashboard />} />
            <Route path="bautagebuch" element={<Bautagebuch />} />
            <Route path="bautagebuch/erstellen" element={<BautagebuchForm />} />
            <Route path="bautagebuch/:id/ansicht" element={<BautagebuchDetail />} />
            <Route path="bautagebuch/:id/bearbeiten" element={<BautagebuchForm />} />
            <Route path="bautagebuch/:id" element={<BautagebuchDetail />} />
            <Route path="zeiterfassung" element={<Zeiterfassung />} />
            <Route path="material" element={<Material />} />
            <Route path="fotos" element={<Fotos />} />
            <Route path="baustellen" element={<Baustellen />} />
            <Route path="mitarbeiter" element={<AdminRoute><Mitarbeiter /></AdminRoute>} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
